import React from 'react';
import styled from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { useTranslations } from '@libs/translations';
import { TitleCard } from './title-card';
import { DescriptionCard } from './description-card';
import { Points } from '@styles';

export const CloudRendering = () => {
  const translations = useTranslations();
  return (
    <View>
      <Content>
        <TitleCard text={translations.t('site.home.opportunities.cloud-rendering.title')} />
        <DescriptionCard text={translations.t('site.home.opportunities.cloud-rendering.description')} />
      </Content>
    </View>
  );
};

const View = styled.div`
  position: relative;
  padding: 16px 16px 40px;
  height: 380px;
  color: ${Colors.white};
  background: image-set(
        url('/images/mainpage/cloud-rendering-bg-mob-1x.webp') 1x type('image/webp'),
        url('/images/mainpage/cloud-rendering-bg-mob-1x.jpg') 1x type('image/jpeg'),
        url('/images/mainpage/cloud-rendering-bg-mob-2x.webp') 2x type('image/webp'),
        url('/images/mainpage/cloud-rendering-bg-mob-2x.jpg') 2x type('image/jpeg')
      )
      50% 100% / 500px auto no-repeat,
    ${Colors.main_black};
  border-radius: 15.13px;

  &::after {
    content: '';
    position: absolute;
    bottom: 25%;
    left: 50%;
    width: 50px;
    height: 50px;
    transform: translate(-50%, 50%);
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='50' height='50' viewBox='0 0 50 50' fill='none'%3e%3crect width='50' height='50' rx='11.4258' fill='white'/%3e%3cpath d='M22.0483 8.73447C24.1034 7.54658 26.6418 7.57241 28.6724 8.80186L41.3853 16.5001C42.3714 17.0972 42.8918 18.0876 42.9487 19.1007L42.9546 19.0958V19.2579C42.9547 19.2739 42.9547 19.2898 42.9546 19.3058V30.6837C42.964 31.7697 42.4408 32.8607 41.3853 33.5001L36.4263 36.5021V28.2901L32.3452 30.7384V38.9728L28.6724 41.1974C26.6419 42.4268 24.1034 42.4534 22.0483 41.2657L8.67236 33.5333C7.59604 32.9111 7.05359 31.826 7.04541 30.7374V19.2872C7.04536 18.1902 7.5877 17.0929 8.67236 16.4659L22.0483 8.73447ZM27.8306 21.6212C26.3079 20.6991 24.4041 20.6799 22.8628 21.5704L16.9282 24.9991L22.8628 28.4298C24.4041 29.3204 26.3078 29.3011 27.8306 28.379L33.4097 25.0001L27.8306 21.6212ZM27.8306 10.1954C26.3078 9.27328 24.4041 9.25389 22.8628 10.1446L9.48584 17.8771C8.40161 18.5041 8.40152 20.0704 9.48584 20.6974L15.3013 24.0587L22.0483 20.1603C24.1034 18.9726 26.642 18.9983 28.6724 20.2276L34.9819 24.048L40.5435 20.6808C41.5896 20.047 41.5895 18.5275 40.5435 17.8937L27.8306 10.1954Z' fill='%232B35EE'/%3e%3c/svg%3e");
  }

  @media ${Points.tablet_landscape} {
    padding: 30px 30px 40px;
    background: image-set(
          url('/images/mainpage/cloud-rendering-bg-desc-1x.webp') 1x type('image/webp'),
          url('/images/mainpage/cloud-rendering-bg-desc-1x.jpg') 1x type('image/jpeg'),
          url('/images/mainpage/cloud-rendering-bg-desc-2x.webp') 2x type('image/webp'),
          url('/images/mainpage/cloud-rendering-bg-desc-2x.jpg') 2x type('image/jpeg')
        )
        100% 100% / 100% auto no-repeat,
      ${Colors.main_black};
  }

  @media ${Points.laptop_wide} {
    height: 500px;
    padding: 40px;
    border-radius: 20px;

    &::after {
      bottom: 27%;
    }
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 10px;

  @media ${Points.tablet_landscape} {
    gap: 15px;
  }

  @media ${Points.laptop_wide} {
    gap: 20px;
  }
`;
